import { render, staticRenderFns } from "./BankTransferIcon.vue?vue&type=template&id=f93124ec&"
import script from "./BankTransferIcon.vue?vue&type=script&lang=js&"
export * from "./BankTransferIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports